<template lang="pug">
md-card.contact.toggle-card.md-elevation-1(md-theme="white" )
  md-card-content
    .heading(@click="toggleVisible")
      md-icon.arrow(v-show="canToggle" v-if="visible") keyboard_arrow_down 
      md-icon.arrow(v-show="canToggle" v-if="!visible") keyboard_arrow_right
      .md-subheading(v-html="heading")
      slot(name="actions")
      md-button.small.md-icon-button.md-dense(@click.stop="$emit('delete')" v-if="canDelete"): md-icon clear
    .content(v-show="visible")
      slot
</template>

<script>
export default {
  name: 'toggle-card',
  props: {
    heading: {},
    canDelete: {
      default: false
    },
    canToggle: {
      type: Boolean,
      default: true
    },
    visibility: {
        type: Boolean,
        default: false
    }
  },
  events: [
    'delete'
  ],
  data() {
    return {
      visible: false
    }
  },
  watch: {
    '$props.visibility'(value) {
        if (this.visible != value) this.visible = value;
    }
  },
  created() {
      this.visible = this.$props.visibility;
  },
  methods: {
    toggleVisible() {
      if (!this.$props.canToggle) return;
      this.visible = !this.visible;
    }
  }
}
</script>

<style lang="sass">
.md-app-content .toggle-card.md-card,
.toggle-card.md-card
  margin: 0 0 10px 0
  z-index: initial
  &.error
    .heading, .md-icon
      color: red
  .md-card-content, .md-card-content:last-of-type
    padding: 0
  .heading
    display: flex
    align-items: flex-start
    justify-content: flex-start
    cursor: pointer
    padding: 5px 5px 5px 10px
    transition: all .3s
    .arrow
      margin: auto 0 auto 0
    .md-subheading
      margin: auto auto auto 0
    .md-button
      float: right
    &:hover
      background: #ebebeb
  .content
    padding: 0 10px 10px 10px
</style>


// WEBPACK FOOTER //
// ToggleCard.vue?216fb3be